
export const emergencyContacts = [
  {
    id: 'police-emergency',
    category: 'law',
    name: 'Police / Fire / Medical Emergency',
    phone: '911',
    description: 'For all life-threatening emergencies requiring immediate police, fire, or medical response.',
    hours: '24/7',
    icon: 'ri-alarm-warning-line',
    color: 'red',
    priority: true,
  },
  {
    id: 'roseville-police',
    category: 'law',
    name: 'Roseville Police Department',
    phone: '(916) 774-5000',
    description: 'Non-emergency police services, reports, and general inquiries.',
    address: '1051 Junction Blvd, Roseville, CA 95678',
    hours: '24/7 Dispatch',
    website: 'https://www.roseville.ca.us/government/departments/police_department',
    icon: 'ri-shield-star-line',
    color: 'teal',
    priority: false,
  },
  {
    id: 'roseville-fire',
    category: 'fire',
    name: 'Roseville Fire Department',
    phone: '(916) 774-5800',
    description: 'Non-emergency fire services, inspections, and community safety programs.',
    address: '401 Oak St, Roseville, CA 95678',
    hours: 'Mon–Fri 8:00 AM – 5:00 PM',
    website: 'https://www.roseville.ca.us/government/departments/fire_department',
    icon: 'ri-fire-line',
    color: 'orange',
    priority: false,
  },
  {
    id: 'sutter-roseville',
    category: 'medical',
    name: 'Sutter Roseville Medical Center',
    phone: '(916) 781-1000',
    description: 'Full-service hospital with 24-hour emergency room, trauma center, and urgent care.',
    address: '1 Medical Plaza Dr, Roseville, CA 95661',
    hours: 'ER Open 24/7',
    website: 'https://www.sutterhealth.org/find-location/facility/sutter-roseville-medical-center',
    icon: 'ri-hospital-line',
    color: 'red',
    priority: false,
  },
  {
    id: 'kaiser-roseville',
    category: 'medical',
    name: 'Kaiser Permanente Roseville',
    phone: '(916) 784-4000',
    description: 'Medical center with emergency department, pharmacy, and specialty services.',
    address: '1600 Eureka Rd, Roseville, CA 95661',
    hours: 'ER Open 24/7',
    website: 'https://healthy.kaiserpermanente.org/northern-california/facilities/roseville-medical-center',
    icon: 'ri-heart-pulse-line',
    color: 'red',
    priority: false,
  },
  {
    id: 'poison-control',
    category: 'medical',
    name: 'Poison Control Center',
    phone: '(800) 222-1222',
    description: 'Immediate guidance for poisoning emergencies. Free, confidential, and available in multiple languages.',
    hours: '24/7',
    icon: 'ri-flask-line',
    color: 'orange',
    priority: true,
  },
  {
    id: 'suicide-prevention',
    category: 'crisis',
    name: 'Suicide & Crisis Lifeline',
    phone: '988',
    description: 'Free, confidential support for people in suicidal crisis or emotional distress. Call or text 988.',
    hours: '24/7',
    icon: 'ri-mental-health-line',
    color: 'teal',
    priority: true,
  },
  {
    id: 'domestic-violence',
    category: 'crisis',
    name: 'National Domestic Violence Hotline',
    phone: '(800) 799-7233',
    description: 'Confidential support, safety planning, and resources for domestic violence survivors.',
    hours: '24/7',
    icon: 'ri-hand-heart-line',
    color: 'teal',
    priority: false,
  },
  {
    id: 'animal-control',
    category: 'community',
    name: 'Placer County Animal Control',
    phone: '(916) 543-7908',
    description: 'Report stray or dangerous animals, animal abuse, or wildlife concerns in the Roseville area.',
    address: '11251 B Ave, Auburn, CA 95603',
    hours: 'Mon–Fri 10:00 AM – 4:00 PM',
    icon: 'ri-bear-smile-line',
    color: 'amber',
    priority: false,
  },
  {
    id: 'pg-and-e',
    category: 'utility',
    name: 'Roseville Electric Utility — Outages',
    phone: '(916) 774-5748',
    description: 'Report power outages, downed power lines, or electrical hazards in Roseville.',
    hours: '24/7 Outage Line',
    icon: 'ri-flashlight-line',
    color: 'amber',
    priority: false,
  },
  {
    id: 'gas-leak',
    category: 'utility',
    name: 'PG&E Gas Emergency',
    phone: '(800) 743-5000',
    description: 'Report gas leaks or gas odors immediately. Leave the area first, then call.',
    hours: '24/7',
    icon: 'ri-fire-line',
    color: 'orange',
    priority: true,
  },
  {
    id: 'water-emergency',
    category: 'utility',
    name: 'Roseville Water — Emergency',
    phone: '(916) 774-5750',
    description: 'Report water main breaks, sewer backups, or flooding emergencies.',
    hours: '24/7 Emergency Line',
    icon: 'ri-drop-line',
    color: 'teal',
    priority: false,
  },
  {
    id: 'red-cross',
    category: 'community',
    name: 'American Red Cross — Gold Country',
    phone: '(916) 993-7070',
    description: 'Disaster relief, shelter services, and emergency assistance for Placer County residents.',
    address: '1565 Exposition Blvd, Sacramento, CA 95815',
    hours: 'Mon–Fri 8:30 AM – 5:00 PM',
    icon: 'ri-first-aid-kit-line',
    color: 'red',
    priority: false,
  },
  {
    id: 'child-protective',
    category: 'crisis',
    name: 'Child Protective Services — Placer County',
    phone: '(916) 872-6549',
    description: 'Report suspected child abuse or neglect. All reports are confidential.',
    hours: '24/7 Hotline',
    icon: 'ri-parent-line',
    color: 'teal',
    priority: false,
  },
  {
    id: 'non-emergency-dispatch',
    category: 'law',
    name: 'Roseville Non-Emergency Dispatch',
    phone: '(916) 774-5000',
    description: 'For non-urgent police matters such as noise complaints, parking issues, or minor incidents.',
    hours: '24/7',
    icon: 'ri-phone-line',
    color: 'teal',
    priority: false,
  },
];

export const safetyCategories = [
  { id: 'all', label: 'All Resources', icon: 'ri-apps-line' },
  { id: 'law', label: 'Law Enforcement', icon: 'ri-shield-star-line' },
  { id: 'fire', label: 'Fire Services', icon: 'ri-fire-line' },
  { id: 'medical', label: 'Medical', icon: 'ri-hospital-line' },
  { id: 'crisis', label: 'Crisis Support', icon: 'ri-mental-health-line' },
  { id: 'utility', label: 'Utilities', icon: 'ri-flashlight-line' },
  { id: 'community', label: 'Community', icon: 'ri-community-line' },
];

export const safetyTips = [
  {
    id: 'home-safety',
    title: 'Home Safety Checklist',
    icon: 'ri-home-heart-line',
    tips: [
      'Install smoke detectors on every level and test monthly',
      'Keep a fire extinguisher in the kitchen and garage',
      'Create and practice a family evacuation plan with two exit routes',
      'Store emergency supplies: water (1 gallon per person per day for 3 days), non-perishable food, flashlight, batteries, and first aid kit',
      'Secure heavy furniture and water heaters to walls for earthquake safety',
      'Know how to shut off gas, water, and electricity in your home',
    ],
  },
  {
    id: 'wildfire-prep',
    title: 'Wildfire Preparedness',
    icon: 'ri-fire-line',
    tips: [
      'Maintain 100 feet of defensible space around your home',
      'Clear dead vegetation, leaves, and debris from gutters and roof',
      'Keep a go-bag packed with essentials: documents, medications, phone charger, cash',
      'Sign up for Placer Alert emergency notifications at placer-alert.org',
      'Know your evacuation zone and routes — check Placer County evacuation maps',
      'Keep car fueled to at least half tank during fire season (June–November)',
    ],
  },
  {
    id: 'earthquake-prep',
    title: 'Earthquake Readiness',
    icon: 'ri-earthquake-line',
    tips: [
      'Practice Drop, Cover, and Hold On with your family',
      'Secure bookshelves, mirrors, and heavy objects to walls',
      'Keep sturdy shoes and a flashlight near your bed',
      'Know how to shut off your gas meter — use a wrench stored nearby',
      'After shaking stops, check for gas leaks and structural damage before re-entering',
      'Have an out-of-area contact person your family can check in with',
    ],
  },
  {
    id: 'extreme-heat',
    title: 'Extreme Heat Safety',
    icon: 'ri-sun-line',
    tips: [
      'Stay hydrated — drink water before you feel thirsty',
      'Avoid outdoor activity between 10 AM and 4 PM during heat waves',
      'Never leave children or pets in parked vehicles',
      'Check on elderly neighbors and those without air conditioning',
      'Roseville cooling centers open at libraries and community centers during heat advisories',
      'Wear lightweight, light-colored, loose-fitting clothing outdoors',
    ],
  },
  {
    id: 'flood-safety',
    title: 'Flood Awareness',
    icon: 'ri-flood-line',
    tips: [
      'Never drive through flooded roadways — Turn Around, Don\'t Drown',
      'Know if your property is in a flood zone at floodsmart.gov',
      'Move valuables and important documents to upper floors during flood warnings',
      'Clear storm drains near your property of leaves and debris',
      'Consider flood insurance — standard homeowner policies do not cover flood damage',
      'Monitor weather alerts via the National Weather Service Sacramento office',
    ],
  },
  {
    id: 'personal-safety',
    title: 'Personal Safety Tips',
    icon: 'ri-user-heart-line',
    tips: [
      'Stay aware of your surroundings, especially in parking lots and at night',
      'Lock car doors and never leave valuables visible inside your vehicle',
      'Report suspicious activity to Roseville PD non-emergency: (916) 774-5000',
      'Use the buddy system when walking or jogging after dark',
      'Register your bicycle with Roseville PD to aid recovery if stolen',
      'Download the Placer Alert app for real-time emergency notifications',
    ],
  },
];

export const emergencyAlertSources = [
  {
    name: 'Placer Alert',
    description: 'Official Placer County emergency notification system. Receive alerts via call, text, or email.',
    url: 'https://www.placer-alert.org',
    icon: 'ri-notification-3-line',
  },
  {
    name: 'Nixle / Roseville PD Alerts',
    description: 'Community advisories, traffic alerts, and safety updates from Roseville Police.',
    url: 'https://www.nixle.com',
    icon: 'ri-shield-check-line',
  },
  {
    name: 'National Weather Service — Sacramento',
    description: 'Severe weather warnings, heat advisories, and flood watches for the Roseville area.',
    url: 'https://www.weather.gov/sto/',
    icon: 'ri-cloud-windy-line',
  },
  {
    name: 'CAL FIRE Incidents',
    description: 'Real-time wildfire information, evacuation orders, and fire conditions for Northern California.',
    url: 'https://www.fire.ca.gov/incidents',
    icon: 'ri-fire-line',
  },
];
